import React, {Component} from 'react';
import Dropzone from 'react-dropzone';
import TaggingField from './TaggingField';
import SearchField from './SearchField';
import i18n from '../../i18n';
import axios from 'axios';
import {remove, isEmpty} from 'lodash';
import swal from 'sweetalert';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {Table, TableHead, TableBody, TableRow, TableCell, TableSortLabel, ListItemIcon} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import {Paper, Link} from '@material-ui/core';
import Grid from '@material-ui/core/Grid/Grid';
import SetRelations from './SetRelations';
import _ from 'lodash';
import EllipsisWithTooltip from '../Formater/EllipsisWithTooltip';
import PreviewButton from '../File/PreviewButton';
import {swalCancelDelete} from '../Form/utils';
import TowLine from '../Text/TwoLine';
import Modal from '@material-ui/core/Modal';
import FormField from '../Form/FormField';
import Chip from "@material-ui/core/Chip";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import iconNames from "../Formater/IconNames";
import LinkIconButton from "../Formater/LinkIconButton";

const styles = theme => ({
        preview: {
            height: 60,
            width: 100,
            '& img': {
                maxHeight: 60,
                maxWidth: 100,
            },
            alignContent: 'center',
        },
        searchBar: {
            textAlign: 'right',
        },
        fileicon: {
            height: 120,
            width: 160,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            color: theme.colors.lightGreyBlue,
        },
        fileiconIcon: {
            height: 50,
            width: 50,
            'background-size': 'inherit',
        },
        fileiconExt: {
            textAlign: 'center',
        },
        card: {
            // display: 'flex',
            position: 'relative',
            borderRadius: 4,
            border: `solid 1px ${theme.colors.paleGray}`,
            marginBottom: 20,
            // padding: "1.9rem",
            boxShadow: 'inherit',
        },
        isDeleted: {
            display: 'none',
        },
        isPic: {},
        isNew: {},
        downloadButton: {
            right: 0,
            top: 0,
            padding: 0,
            minWidth: 30,
            minHeight: 30,
        },
        details: {
            display: 'flex',
            flexDirection: 'row',
            padding: 0,
            margin: '0 30px 0 0',
            '&:last-child': {
                padding: 0,
            },
        },
        detailsLabel: {
            'text-align': 'right',
        },
        detailsRow: {
            'padding-top': 0,
            'padding-bottom': 0,
        },
        content: {
            // flex: '1 0 auto',
            // width: 350,
            // padding: 0,
            // margin: 0,
        },
        deleteFile: {
            right: 0,
            top: 0,
            padding: 0,
            minWidth: 30,
            minHeight: 30,
        },
        paper: {
            padding: '1.9rem',
        },
        dropzone: {
            width: '100%',
            height: 300,
            color: theme.colors.lightGreyBlue,
            display: 'flex',
            flex: '1 0 auto',
            textAlign: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            backgroundColor: theme.colors.paleGray,
        },
        dropzoneIcon: {
            fontSize: 86,
            color: theme.colors.lightGreyBlue,
        },
        dropzoneReplace: {
            width: 'auto',
            height: 'auto',
            display: 'inline-block',
        },
        dropzoneIconReplace: {
            fontSize: 20,
            color: theme.colors.white,
        },
        deleteFileIcon: {
            fontSize: 20,
        },
        downloadButtonIcon: {
            fontSize: 24,
        },
        relationList: {
            paddingTop: '0px',
            paddingBottom: '0px',
        },
        iconButton: {
            width: 32,
            height: 32,
            padding: 0
        },
        icon: {
            fontSize:20,
        },
        relationListDelete: {
            position: 'absolute',
            top: 0,
            right: 0,
            fontSize: 18,
            marginTop: -8,
            marginRight: -8,
        },
        tags: {
            // flex: '1 0 auto',
            // marginRight: 30,
        },
        tagsInput: {
            width: '100%',
            marginTop: '0px',
            marginBottom: '0px',
            paddingTop: '0px',
            paddingBottom: '10px',
            '& input': {
                paddingTop: '0px',
            },
        },
        buttons: {
            // flex: '1 0 auto',
            width: '100%',
            margin: '15px 0 0 0',
            '& button': {
                marginBottom: theme.spacing.unit * 1,
            },
        },
        vSpace: {
            marginTop: theme.spacing.unit * 4,
            marginBottom: theme.spacing.unit * 2,
        },
        iconSpace: {
            marginRight: theme.spacing.unit * 0.5,
            marginLeft: theme.spacing.unit * 0.5,
        },
        tableCell: {
            verticalAlign: 'middle',
        },
        modalPaper: {
            position: 'absolute',
            width: 500,
            top: '50%',
            left: '50%',
            marginTop: -70,
            marginLeft: -250,
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[5],
            padding: theme.spacing.unit,
            outline: 'none',
        },
    })
;

/**
 * https://react-dropzone.js.org/
 */
class MediaDropZone extends Component {

    constructor(props) {
        super(props);
        const uploadConfig = Object.assign({
            'urlUnlink': null,
            'urlLink': null,
            'urlSearch': null,
            'url': null,
            'urlTag': null,
            'urlReplace': null,
            'urlRename': null,
            'files': [],
            'tab': 0,
        }, props.uploadConfig);

        if (props.onNewFile) {
            this.onNewFile = props.onNewFile;
        }

        this.state = {
            searchQuery: '',
            tab: props.uploadConfig.tab || 0,
            files: props.uploadConfig.files,
            uploadConfig: uploadConfig,
            searchedFiles: [],
            editNameModal: false,
            editNameText: null,
            editNameFile: null,
        };
    }

    onNewFile = null;

    refreshFilesState(newfiles) {
        if (!newfiles) {
            newfiles = [];
        }
        this.setState({
            files: [].concat(newfiles, this.state.files),
        });
    }

    updateFileRelations(updatedfile) {
        let files = this.state.files;
        _.each(files, (file) => {
            if (file.iId === updatedfile.iId) {
                file.aRelations = updatedfile.aRelations;
            }
        });
        this.setState({
            files: files,
        });
    }

    doUnlink(rel, idx, file) {
        swal({
            title: i18n.get('file.relations.label'),
            text: i18n.get('file.relations.question'),
            dangerMode: true,
            icon: 'warning',
            ...swalCancelDelete(),
        }).then((confirmed) => {
            if (confirmed) {
                axios.delete(this.state.uploadConfig.urlUnlink, {data: {relid: rel.id}}).then((response) => {
                    swal({
                        text: i18n.get('file.relations.removed'),
                        icon: 'success',
                    }).then(() => {
                        _.remove(file.aRelations, (itm, relidx) => {
                            return idx === relidx;
                        });
                        this.refreshFilesState();
                    });
                });
            }
        });
    }

    doAutoLink(file) {
        if (!isEmpty(this.state.uploadConfig.urlLink)) { // darf automatisch linken
            axios.post(this.state.uploadConfig.urlLink, {'file_id': [file.sHash]}).then((response) => {
                if (response.data && response.data.refs) {
                    file.aRelations = [].concat(response.data.refs, file.aRelations);
                }
                this.refreshFilesState();
            });
        }
    }

    onChangeTab = (event, value) => {
        this.setState({tab: value});
    };


    onChangeTags(file, e) {
        file.sTags = e.target.value;
        this.refreshFilesState();
    }

    doSearch(q) {
        // Todo: start Animation
        axios.get(this.state.uploadConfig.urlSearch, {params: {q}}).then((response) => {
            // Todo: Stop Animation
            if (response.data && response.data.aResultsFiles) {
                this.setState({
                    searchedFiles: response.data.aResultsFiles,
                    tab: 1,
                });
            }
        }).catch(function (error) {
            // Todo Handle Error
            // Todo: Stop Animation
        });
    }

    onBlurTags(file) {
        axios.post(this.state.uploadConfig.urlTag, {'file_id': file.sHash, 'tags': file.sTags}).then((response) => {
            // done do nothing
        });
    }

    onDeleteFile(file) {
        // TODO: ggf. abfrage welche Relationen und Dateien noch vorhanden sind?
        swal({
            title: i18n.get('file.delete.label'),
            text: i18n.get('file.delete.question'),
            dangerMode: true,
            icon: 'warning',
            ...swalCancelDelete(),
        }).then((confirmed) => {
            if (confirmed) {
                axios.delete(file.sRouteDelete, {}).then((response) => {
                    if (response.data && response.data.success) {
                        file.isDeleted = true;
                        this.refreshFilesState();
                    }
                });
            }
        });
    }

    onRename(file, name, cbDone) {
        axios.post(this.state.uploadConfig.urlRename, {file_id: file.sHash, name}).then((response) => {
            if (response.data && response.data.success) {
                file.sName = name;
                this.refreshFilesState();
                if (cbDone) {
                    cbDone();
                }
            }
        });
    }

    onDropReplace(orig, newFiles) {
        this.onDrop(newFiles, (file) => {
            axios.post(this.state.uploadConfig.urlReplace, {
                file_id: orig.sHash,
                new_file_id: file.sHash
            }).then((response) => {
                if (response.data && response.data.success) {
                    // TODO: alten ausblenden
                }
            });
        });
    }

    onDrop(newfiles, cbFileDone) {
        const config = {headers: {'Content-Type': 'multipart/form-data'}};
        let fd = new FormData();

        newfiles.map((file) => {
            fd.append('File[]', file);
        });

        axios.post(this.state.uploadConfig.url, fd, config).then((response) => {
            newfiles.map((file, idx) => {
                if (response.data && response.data.file_id && response.data.file_id.length > idx) {
                    try {
                        file.sHash = response.data.file_id[idx] || '';
                        file.icon = response.data.icons[idx] || '';
                        file.isImage = response.data.pics[idx] || '';
                        file.mcePic = response.data.mcePic[idx] || '';
                        file.sPrevPic = response.data.prevPic[idx] || '';
                        file.sTags = response.data.tags[idx] || '';
                        file.sExt = response.data.ext[idx] || '';
                        file.iId = response.data.id[idx] || '';
                        file.id = response.data.id[idx] || '';
                        file.isNew = true;
                        file.isDeleted = false;

                        this.doAutoLink(file);
                        if (this.onNewFile) {
                            this.onNewFile(file);

                        }
                        if (cbFileDone) {
                            cbFileDone(file);
                        }
                    } catch (ex) {
                        console.error(ex);
                    }
                }
            });
            this.refreshFilesState(newfiles);
        }).catch(error => {
            console.error(error);
        });
    }

    renderRelations(file, classes) {
        return (
            <List>
                {
                    file.aRelations ? (
                        file.aRelations.length > 0 ? file.aRelations.map((rel, idx) => (
                                this.renderRelation(file, rel, idx, classes)
                            ),
                        ) : ''
                    ) : ''
                }
            </List>
        );
    }

    renderRelation(file, rel, idx, classes) {
        return (



            <ListItem key={rel.id || Math.random()} className={classes.relationList}>
                {/*<Button variant="outlined" className={classes.relationListButton} href={rel.route}>
                    <Icon className={classes.relationListPrimaryIcon}>{rel.icon}</Icon>
                    <span>{rel.name}</span>
                </Button>
                <ListItemSecondaryAction >
                    <IconButton edge="end" aria-label="delete" variant="outlined"
                                onClick={this.doUnlink.bind(this, rel, idx, file)}>
                         <Icon>clear</Icon>
                     </IconButton>
                </ListItemSecondaryAction>*/}

                <LinkIconButton
                    text={rel.name}
                    href={rel.route}
                    icon={rel.icon}
                />
                <ListItemSecondaryAction >
                    <IconButton edge="end" aria-label="delete" variant="outlined" className={classes.iconButton}
                                onClick={this.doUnlink.bind(this, rel, idx, file)}>
                        <Icon className={classes.icon}>clear</Icon>
                    </IconButton>
                </ListItemSecondaryAction>

                {/*<Button className={classes.relationListButton}*/}
                {/*        onClick={this.doUnlink.bind(this, rel, idx, file)}*/}
                {/*>*/}
                {/*    <Icon className={classes.relationListDelete}>highlight_off</Icon>*/}
                {/*</Button>*/}
            </ListItem>
        );
    }

    renderTags(file, classes) {
        if (file) {
            if (!file.sTags) {
                file.sTags = '';
            }
            return (
                <TaggingField
                    className={classes.tagsInput}
                    onChange={this.onChangeTags.bind(this, file)}
                    onBlur={this.onBlurTags.bind(this, file)}
                    file={file}
                    label={i18n.get('file.tag.input.placeholder')}
                    title={i18n.get('file.tag.input.title')}
                    helperText={i18n.get('file.tag.input.helper')}
                />
            );
        }
        return null;
    }

    renderSearch() {
        return (
            <div className={this.props.classes.searchBar}>
                <SearchField
                    doSearch={this.doSearch.bind(this)}
                    value={this.state.searchQuery}
                    label={i18n.get('file.search.placeholder')}
                />
            </div>
        );
    }

    renderDetailsRow(label, value, classes) {
        return (
            <span>{label + ': ' + value}</span>
        );
    }

    renderDetails(file, classes) {
        if (file) {
            return (
                <TowLine
                    main={<EllipsisWithTooltip>{file.sName || file.name || '-'}</EllipsisWithTooltip>}
                    sub={<Tooltip
                        title={this.renderDetailsRow(i18n.get('file.details.uploadedBy'), file.oCreator ? file.oCreator.name : '-', classes)}>
                        <Typography>
                            {this.renderDetailsRow(i18n.get('file.details.uploaded'), file.sCreated || '-', classes)}
                        </Typography>
                    </Tooltip>}
                />
            );
        }
        return null;
    }

    renderPreview(file) {
        if (!file.icon) {
            file.icon = 'file-regular';
        }
        if (file && file.sPrevPic) {
            return (
                <Grid container
                      spacing={0}
                      className={this.props.classes.preview}
                      direction="row"
                      justify="center"
                      alignItems="center"
                >
                    <Grid item xs={12}>
                        <PreviewButton
                            file={file}
                        />
                    </Grid>
                </Grid>
            );
        }
        return (
            <div className={this.props.classes.fileicon}>
                <CardMedia
                    className={this.props.classes.fileiconIcon}
                    image={'/images/filetype/' + file.icon + '.svg'}
                    title=""
                />
                <div className={this.props.classes.fileiconExt} color="primary">{file.sExt}</div>
            </div>
        );
    }

    renderDelete(file, classes) {
        if (file) {
            return <Button variant="outlined" color="primary" className={classes.deleteFile}
                           onClick={this.onDeleteFile.bind(this, file)}><Icon>clear</Icon></Button>;
        }
        return null;
    }

    renderDownload(file, classes) {
        if (file && file.sRoute) {
            return (
                <a href={file.sRoute} className={classes.downloadButton}>
                    <Button variant="contained" color="primary" className={classes.downloadButton}>
                        <Icon className={classes.downloadButtonIcon}>cloud_download</Icon>
                    </Button>
                </a>
            );
        }
        return null;
    }

    renderReplace(file, classes) {
        if (file && file.sHash) {
            return (
                <Tooltip title={i18n.get('file.replace')}>
                    <Dropzone onDrop={this.onDropReplace.bind(this, file)} multiple={true}
                              className={this.props.classes.dropzoneReplace}>
                        <Button variant="contained" color="primary" className={classes.downloadButton}>
                            <Icon className={this.props.classes.dropzoneIconReplace}>autorenew</Icon>
                        </Button>
                    </Dropzone>
                </Tooltip>
            );
        }
        return null;
    }

    renderRename(file, classes) {
        if (file && file.sName) {
            return (
                <Tooltip title={i18n.get('file.rename')}>
                    <Button variant="contained" color="primary" className={classes.downloadButton} onClick={() => {
                        this.setState({editNameModal: true, editNameText: file.sName, editNameFile: file});
                    }}>
                        <Icon className={this.props.classes.dropzoneIconReplace}>edit</Icon>
                    </Button>
                </Tooltip>
            );
        }
        return null;
    }

    renderSetRelation(file, classes) {
        // TODO: Verlinkung Setzen geht nicht
        // if (file) {
        //     return (
        //         <SetRelations
        //             file={file}
        //             urlLinkOverlay={this.state.uploadConfig.urlLinkOverlay}
        //             urlLinkOverlaySearch={this.state.uploadConfig.urlLinkOverlaySearch}
        //             updateFileRelations={this.updateFileRelations.bind(this)}
        //         />
        //     );
        // }
        return null;
    }

    renderFile(file) {
        if (file) {
            let classes = this.props.classes;
            let cardclasses = classes.card;
            cardclasses += (file.isDeleted ? ' ' + classes.isDeleted : '');
            cardclasses += (file.isImage ? ' ' + file.isPic : '');
            cardclasses += (file.isNew ? ' ' + classes.isNew : '');

            return (
                <TableRow key={file.sHash || file.sName || file.filename || Math.random()}>
                    <TableCell className={classes.tableCell}>
                        {this.renderPreview(file)}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                        {this.renderDetails(file, this.props.classes)}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                        {this.renderTags(file, this.props.classes)}
                    </TableCell>
                    <TableCell className={classes.tableCell} align='center'>
                        {this.renderDelete(file, this.props.classes)}
                        <span style={{padding: '2px'}}/>
                        {this.renderDownload(file, this.props.classes)}
                        <span style={{padding: '2px'}}/>
                        {this.renderReplace(file, this.props.classes)}
                        <span style={{padding: '2px'}}/>
                        {this.renderRename(file, this.props.classes)}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                        {this.renderRelations(file, this.props.classes)}
                    </TableCell>
                </TableRow>
            );
        }
        return null;
    }

    render() {
        const {order, classes} = this.props;
        return (
            <div className="dropZoneSection">
                <Typography variant="h2" className={this.props.classes.vSpace}>{i18n.get('file.upload')}</Typography>
                <Paper className={this.props.classes.paper}>
                    <Dropzone onDrop={this.onDrop.bind(this)} multiple={true} className={this.props.classes.dropzone}>
                        <Icon className={this.props.classes.dropzoneIcon}>cloud_upload</Icon>
                        <p>{i18n.get('file.drop')}</p>
                        <Button variant="contained" color='primary'>{i18n.get('file.select')}</Button>
                    </Dropzone>
                </Paper>
                {this.renderSearch()}
                <Typography variant="h2" className={this.props.classes.vSpace}>{i18n.get('file.title')}</Typography>
                <Paper className={this.props.classes.paper}>
                    <Tabs value={this.state.tab} onChange={this.onChangeTab.bind(this)}>
                        <Tab label={i18n.get('file.search.all')}/>
                        {/*<Tab label={i18n.get('file.search.pictures')}/>*/}
                        <Tab label={i18n.get('file.search.results')}/>
                    </Tabs>
                    {this.state.tab === 0 && <React.Fragment>
                        <div style={{overflowX: 'auto', overflowY: 'hidden'}}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            align='center'><Typography>{i18n.get('file.table.image')}</Typography></TableCell>
                                        <TableCell align='center'>
                                            {
                                                this.props.hasOwnProperty('order') ?
                                                    (<Tooltip
                                                        title="Sort"
                                                    >
                                                        <TableSortLabel
                                                            active={order != null ? true : false}
                                                            direction={order == 'desc' ? 'asc' : 'desc'}
                                                        >
                                                            <Link
                                                                underline='none'
                                                                href={`/f/sort/${order}`}
                                                            >
                                                                <Typography>
                                                                    {i18n.get('file.table.name_date')}
                                                                </Typography>
                                                            </Link>
                                                        </TableSortLabel>
                                                    </Tooltip>) :
                                                    <Typography>
                                                        {i18n.get('file.table.name_date')}
                                                    </Typography>
                                            }
                                        </TableCell>
                                        <TableCell align='center'><Typography>{i18n.get('file.table.tags')}</Typography></TableCell>
                                        <TableCell
                                            align='center'><Typography>{i18n.get('file.table.actions')}</Typography></TableCell>
                                        <TableCell
                                            align='center'><Typography>{i18n.get('file.table.relations')}</Typography></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.files && this.state.files.map(f => (
                                        this.renderFile(f)
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                        {this.props.children}
                    </React.Fragment>}
                    {/*{this.state.tab === 1 && <Typography component="div">Fotos</Typography>}*/}
                    {this.state.tab === 1 && <div>{(
                        this.state.searchedFiles.length > 0 ? this.state.searchedFiles.map(f => (
                            this.renderFile(f)
                        )) : <span>{i18n.get('file.search.empty')}</span>)
                    }</div>}
                </Paper>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.editNameModal}
                    onClose={() => {
                        this.setState({editNameText: null, editNameModal: false, editNameFile: null});
                    }}
                >
                    <div className={classes.modalPaper}>
                        <FormField name={'name'} value={this.state.editNameText} onChange={(e) => {
                            this.setState({editNameText: e.target.value});
                        }}>

                        </FormField>
                        <Grid container
                              direction="row"
                              justify="space-between"
                              alignItems="flex-start">
                            <Grid item xs={2}>
                                <Button variant="contained" color="primary" className={classes.downloadButton}
                                        onClick={() => {
                                            this.onRename(this.state.editNameFile, this.state.editNameText, () => {
                                                this.setState({
                                                    editNameText: null,
                                                    editNameModal: false,
                                                    editNameFile: null
                                                });
                                            });
                                        }}>
                                    <Icon className={this.props.classes.dropzoneIconReplace}>save</Icon>
                                </Button>
                            </Grid>
                            <Grid item xs={3}>
                                <Button variant="contained" color="primary" onClick={() => {
                                    this.setState({editNameText: null, editNameModal: false, editNameFile: null});
                                }}>
                                    {i18n.get('default.cancel')}
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                </Modal>
            </div>
        );
    }
}

MediaDropZone.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MediaDropZone);
